import * as React from "react";
import { useField } from 'informed';
import * as classnames from 'classnames';
import '../components/Switch.css';

interface CheckboxProps {
    id: string;
    field: string;
    label: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    onChange?: (boolean) => void;
    automationId?: string;
}

export const Checkbox = ({ id, field, label, disabled, required, onChange, automationId = null }: CheckboxProps) => {
    const { fieldState, fieldApi } = useField<boolean>({ field: field });
    const { value } = fieldState;
    const { setValue } = fieldApi;

    const togglerClasses = classnames(
        'switch-toggle',
        `switch-toggle--${value ? 'on' : 'off'}`
    )

    return (
        <>
            <div className="switch switch--small" data-automationid={automationId} onClick={() => {
                if (onChange !== null && onChange !== undefined)
                    onChange(!value);

                setValue(!value);
            }}>
                <div className={togglerClasses}></div>
                <label>{label}</label>
            </div>
        </>
    );
}
